import React, { useEffect } from "react";
import { Box, Typography, Divider, Link } from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "../img/Logo_B.png";
import "../../styles/components-styles/Footer.css";
// Reusable Typography Component
const FooterText = ({ children, fontWeight = "500", href, onClick }) => (
  <Link
    href={href}
    underline="none"
    sx={{ cursor: "pointer", color: "inherit" }}
    onClick={onClick}
  >
    <Typography
      variant="body2"
      sx={{ fontWeight, fontSize: "16px", lineHeight: "30px", mb: 1 }}
    >
      {children}
    </Typography>
  </Link>
);

const Footer = ({ scrollToTestimonials }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollToTestimonials) {
      scrollToTestimonials();
    }
  }, [location, scrollToTestimonials]);

  const termsClick = () => {
    navigate("/termscondition");
  };

  return (
    <Box className="footer-container">
      {/* Left Section */}
      <Box className="footer-left">
        <img src={Logo} alt="Logo" className="footer-logo" />
        <FooterText>
          Hrishi’s Holistic Hub is a nurturing space where students thrive
          academically, emotionally, and socially.
        </FooterText>
        <Box className="footer-contact">
          <FooterText className="footer-heading">GET IN TOUCH</FooterText>
          <FooterText href="tel:+1234567890">
            Call Us : +91 8766551964
          </FooterText>
          <FooterText href="contact@hrishisholistichub.com">
            Mail Us : contact@hrishisholistichub.com
          </FooterText>
        </Box>
      </Box>

      {/* Middle Section */}
      <Box className="footer-middle">
        <NavLink
          to="/about"
          className="footer-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          {" "}
          <FooterText fontWeight="600">About Us</FooterText>{" "}
        </NavLink>
        <NavLink
          to="/courses"
          className="footer-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          {" "}
          <FooterText fontWeight="600">Courses</FooterText>{" "}
        </NavLink>
        <NavLink className="footer-link">
          <FooterText
            fontWeight="600"
            onClick={() => {
              if (
                location.pathname === "/" ||
                location.pathname === "/courses"
              ) {
                scrollToTestimonials();
              } else {
                navigate("/", { state: { scrollToTestimonials: true } });
              }
            }}
          >
            Testimonials
          </FooterText>
        </NavLink>
        <NavLink to="/" className="footer-link">
          <FooterText fontWeight="600">Privacy Policy</FooterText>
        </NavLink>
        <NavLink to="/termscondition" className="footer-link">
          <FooterText
            fontWeight="600"
            onClick={() => {
              termsClick();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Terms & Conditions
          </FooterText>
        </NavLink>
      </Box>

      {/* Divider */}
      <Divider orientation="vertical" flexItem className="footer-divider" />

      {/* Right Section */}
      <Box className="footer-right">
        <NavLink to="/courses" className="footer-link">
          {" "}
          <FooterText fontWeight="600">English Language</FooterText>
        </NavLink>
        <NavLink to="/courses" className="footer-link">
          {" "}
          <FooterText fontWeight="600">Mathematics</FooterText>
        </NavLink>
        <NavLink to="/courses" className="footer-link">
          {" "}
          <FooterText fontWeight="600">Social Studies</FooterText>
        </NavLink>
        <NavLink to="/courses" className="footer-link">
          {" "}
          <FooterText fontWeight="600">Science</FooterText>{" "}
        </NavLink>
        <NavLink to="/creative-writing-course" className="footer-link">
          {" "}
          <FooterText fontWeight="600">Creative Writing Course</FooterText>{" "}
        </NavLink>
      </Box>
    </Box>
  );
};

export default Footer;
